import { LoadingButton } from '@mui/lab'
import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import { defaultModalStyle, defaultModalZIndex, minButtonWidth } from 'const'
import React from 'react'

interface Props {
  isOpen: boolean
  entityToRemove: string
  loading: boolean
  description?: string
  handleClose: () => void
  handleConfirm: () => void
}

const modalStyle = {
  ...defaultModalStyle,
  width: 420,
}

const ConfirmRemoveModal = (props: Props) => {
  const { isOpen, description, entityToRemove, loading, handleClose, handleConfirm } = props

  return (
    <Modal sx={defaultModalZIndex} open={isOpen}>
      <Box sx={modalStyle}>
        <Typography variant="h5" mb={3}>
          Delete Record
        </Typography>
        <Typography variant="body1">
          {description || `You are trying to delete ${entityToRemove}.`}
        </Typography>
        <Typography variant="body1" mb={5}>
          Please confirm the action.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 4 }}>
          <Button variant="outlined" onClick={handleClose} sx={minButtonWidth}>
            Close
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={handleConfirm}
            sx={minButtonWidth}
          >
            Confirm
          </LoadingButton>
        </Stack>
      </Box>
    </Modal>
  )
}

export default ConfirmRemoveModal
